/**
 * SCRUM-411: página pública que abre el QR de check-in — sin sesión.
 */
import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export const Route = createFileRoute("/market_/$slug/clase-checkin/$token")({
  component: ClassCheckinPage,
  head: () => ({ meta: [{ title: "Check-in de clase" }] }),
});

function ClassCheckinPage() {
  const { slug, token } = Route.useParams();
  const [state, setState] = useState<"loading" | "ok" | "error">("loading");
  const [message, setMessage] = useState("");
  const [detail, setDetail] = useState("");

  useEffect(() => {
    fetch(`/api/market/${slug}/class-checkin/${token}`, { method: "POST" })
      .then(async (r) => {
        const d = await r.json();
        if (!r.ok) {
          setState("error");
          setMessage(d.error ?? "No se pudo procesar el check-in");
          return;
        }
        setState("ok");
        setMessage(`¡Check-in listo, ${d.customerName}!`);
        setDetail(
          d.serviceName ? `${d.serviceName} · ${d.sessionDate ?? ""} ${d.startTime?.slice(0, 5) ?? ""}` : "",
        );
      })
      .catch(() => {
        setState("error");
        setMessage("Error de red");
      });
  }, [slug, token]);

  return (
    <div className="mx-auto flex min-h-dvh max-w-sm flex-col items-center justify-center gap-4 px-4 text-center">
      {state === "loading" ? (
        <Loader2 className="h-10 w-10 animate-spin text-muted-foreground" />
      ) : state === "ok" ? (
        <CheckCircle2 className="h-14 w-14 text-primary" />
      ) : (
        <XCircle className="h-14 w-14 text-destructive" />
      )}
      <h1 className="text-xl font-bold">{state === "loading" ? "Procesando…" : message}</h1>
      {detail ? <p className="text-sm text-muted-foreground">{detail}</p> : null}
    </div>
  );
}
